<p-dialog id="chartLoading" [(visible)]="chartLoading" [modal]="true" [style]="{width: '100vw'}">
    <div class="loader row col-md-12">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class=" messageLoader"> {{loadingText}}</div>
    </div>
</p-dialog>